import { createSlice } from '@reduxjs/toolkit';

interface IUserState {
  id: string;
  email: string;
  name: string;
  isLoaded: boolean;
  hasProSubscription: boolean;
  userAvatar: null | string;
}

const initialState = {
  id: '',
  email: '',
  name: '',
  isLoaded: false,
  hasProSubscription: true,
  userAvatar: null,
} as IUserState;

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUser: (state: IUserState, action) => ({
      ...state,
      ...action.payload,
      isLoaded: true,
    }),
    resetUser: () => ({
      ...initialState,
      isLoaded: true,
    }),
  },
});

export const { updateUser, resetUser } = userSlice.actions;

export default userSlice.reducer;
